import React from 'react';
import WizardVStack from '../WizardVStack/WizardVStack';
import { WizardItemSubType } from '../../../Enums/WizardItemSubtype.enum';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import WizardHStack from '../WizardHStack/WizardHStack';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.CONTAINER }>;
	onSubmit: (values: object) => void;
}

const WizardContainer: React.FC<Props> = ({ item, onSubmit }) => {
	switch (item.subtype) {
		case WizardItemSubType.V_STACK:
			return <WizardVStack item={item} onSubmit={onSubmit} />;
		case WizardItemSubType.H_STACK:
			return <WizardHStack item={item} onSubmit={onSubmit} />;
		default:
			return <>Unsupported container subtype: {item.subtype}</>;
	}
};

export default WizardContainer;
